import * as PlotSteps from "@fae/source/data/plot/steps.js"

import items from "./items.jsx"
import passives from "./passives.jsx"

export default {
    "affiliation": "good",
    "rollcount": 5,
    "maxrollcount": 5,
    "equipments": {
        // ...
    },
    "inventory": {
        "kindling": 13,
        "items": {
            // "0": {"name": "Axe", "key": 0},
            // "1": {"name": "Gun", "key": 1},
            // "2": {"name": "Sword", "key": 2},
            // "3": {"name": "Daggers", "key": 3},
            // "4": {"name": "Spear", "key": 4},
            // "5": {"name": "Bow", "key": 5},
            // "7": {"name": "Food", "type": "food", "key": 7},
        },
    },
    "units": {
        "ashe": {
            "key": "ashe",
            "jobKey": "ember/ashe",
            "isOverworldVisible": true,
            "isOverworldRevealed": false,
            "isOverworldSelectable": true,
        },
        "gwyn": {
            "key": "gwyn",
            "jobKey": "ember/gwyn",
            "isOverworldVisible": true,
            "isOverworldRevealed": false,
            "isOverworldSelectable": true,
        },
        "kullervo": {
            "key": "kullervo",
            "jobKey": "ember/kullervo",
            "isOverworldVisible": true,
            "isOverworldRevealed": false,
            "isOverworldSelectable": true,
        },
        "mara": {
            "key": "mara",
            "jobKey": "ember/mara",
            "isOverworldVisible": true,
            "isOverworldSelectable": false,
        },
        // "hugo": {
        //     "key": "hugo",
        //     "jobKey": "ember/hugo",
        //     "isOverworldVisible": true,
        //
        //     "items": [
        //         {
        //             "name": "Axe",
        //             "element": "earth",
        //             "attacktype": "steel",
        //             "attackrange": 1,
        //             "power": 20,
        //             "skillKeys": ["attack"],
        //             "weaponImageKey": "ember-axe",
        //         },
        //         {
        //             "name": "Skillet",
        //             "element": "fire",
        //             "attacktype": "magic",
        //             "attackrange": 1,
        //             "power": 20,
        //             "skillKeys": ["heal"],
        //             "weaponImageKey": "ember-red-staff",
        //             // "weaponImage": require("@fae/source/assets/images/ember-tactics/sprites/weapons/wpn-memento-hugopan.png"),
        //         },
        //     ]
        // },
        // "neve": {
        //     "key": "neve",
        //     "jobKey": "ember/neve",
        //     "isOverworldVisible": true,
        //     "isOverworldSelectable": false,
        //
        //     // "items": [
        //     //     {
        //     //         "name": "Spear",
        //     //         "element": "water",
        //     //         "attacktype": "steel",
        //     //         "attackrange": {
        //     //             "min": 1,
        //     //             "max": 1,
        //     //             "directions": [
        //     //                 {"x": -1, "y": 0},
        //     //                 {"x": +1, "y": 0},
        //     //                 {"x": 0, "y": -1},
        //     //                 {"x": 0, "y": +1},
        //     //
        //     //                 {"x": -1, "y": -1},
        //     //                 {"x": -1, "y": +1},
        //     //                 {"x": +1, "y": -1},
        //     //                 {"x": +1, "y": +1},
        //     //             ]
        //     //         },
        //     //         "power": 20,
        //     //         "skillKeys": ["attack"],
        //     //         "weaponImageKey": "ember-spear",
        //     //         // "weaponImage": require("@fae/source/assets/images/ember-tactics/sprites/weapons/wpn-memento-neveharpoon.png"),
        //     //     },
        //     // ],
        //
        //     "passives": [
        //         // ...
        //     ],
        //     "items": {
        //         "0": {...items["icicle-lance"], "power": 20},
        //         "1": {...items["icicle-lance"], "power": 10},
        //         "2": {...items["icicle-lance"], "power": 10},
        //         "3": {...items["flaming-crossbow"], "power": 10},
        //         "4": {...items["flaming-crossbow"], "power": 10},
        //         "5": {...items["flaming-crossbow"], "power": 20},
        //     },
        //     "defaultItems": {
        //         "0": {...items["basic-strike"], "power": 10},
        //         "1": {...items["basic-strike"], "power": 10},
        //         "2": {...items["basic-shield"], "power": 10},
        //         "3": {...items["basic-shield"], "power": 10},
        //         "4": {...items["basic-strike"], "power": 10},
        //         "5": {...items["basic-strike"], "power": 10},
        //     },
        // },
        // "ylfa": {
        //     "key": "ylfa",
        //     "jobKey": "ember/ylfa",
        //     "isOverworldVisible": true,
        //     "isOverworldSelectable": false,
        //
        //     // "items": [
        //     //     {
        //     //         "name": "Daggers",
        //     //         "element": "fire",
        //     //         "attacktype": "steel",
        //     //         "attackrange": {
        //     //             "min": 1,
        //     //             "max": 2,
        //     //             "orthogonal": true,
        //     //             "diagonal": true,
        //     //         },
        //     //         "power": 20,
        //     //         "skillKeys": ["attack"],
        //     //         "weaponImageKey": "ember-daggers",
        //     //         // "weaponImage": require("@fae/source/assets/images/ember-tactics/sprites/weapons/wpn-memento-ylfaclaws.png"),
        //     //     },
        //     // ],
        //
        //     "passives": [
        //         // ...
        //     ],
        //     "items": {
        //         "0": {...items["icicle-lance"], "power": 20},
        //         "1": {...items["icicle-lance"], "power": 10},
        //         "2": {...items["icicle-lance"], "power": 10},
        //         "3": {...items["flaming-crossbow"], "power": 10},
        //         "4": {...items["flaming-crossbow"], "power": 10},
        //         "5": {...items["flaming-crossbow"], "power": 20},
        //     },
        //     "defaultItems": {
        //         "0": {...items["basic-strike"], "power": 10},
        //         "1": {...items["basic-strike"], "power": 10},
        //         "2": {...items["basic-shield"], "power": 10},
        //         "3": {...items["basic-shield"], "power": 10},
        //         "4": {...items["basic-strike"], "power": 10},
        //         "5": {...items["basic-strike"], "power": 10},
        //     },
        // },
        // "vasilisa": {
        //     "key": "vasilisa",
        //     "jobKey": "ember/vasilisa",
        //     "isOverworldVisible": true,
        //     "isOverworldSelectable": false,
        //
        //     // "items": [
        //     //     {
        //     //         "name": "Daggers",
        //     //         "element": "fire",
        //     //         "attacktype": "steel",
        //     //         "attackrange": {
        //     //             "min": 1,
        //     //             "max": 2,
        //     //             "orthogonal": true,
        //     //             "diagonal": true,
        //     //         },
        //     //         "power": 20,
        //     //         "skillKeys": ["attack"],
        //     //         "weaponImageKey": "ember-daggers",
        //     //         // "weaponImage": require("@fae/source/assets/images/ember-tactics/sprites/weapons/wpn-memento-vasineedle.png"),
        //     //     },
        //     // ],
        //
        //     "passives": [
        //         // ...
        //     ],
        //     "items": {
        //         "0": {...items["icicle-lance"], "power": 20},
        //         "1": {...items["icicle-lance"], "power": 10},
        //         "2": {...items["icicle-lance"], "power": 10},
        //         "3": {...items["flaming-crossbow"], "power": 10},
        //         "4": {...items["flaming-crossbow"], "power": 10},
        //         "5": {...items["flaming-crossbow"], "power": 20},
        //     },
        // },
        // "tariq": {
        //     "key": "tariq",
        //     "jobKey": "ember/tariq",
        //     "isOverworldVisible": true,
        //     "isOverworldSelectable": false,
        //
        //     "maxhealth": 70,
        //     "passives": [
        //         // ...
        //     ],
        //     "items": {
        //         "0": {...items["starfall"], "power": 20},
        //         "1": {...items["daggers"], "power": 10},
        //         "2": {...items["starfall"], "power": 20},
        //         "3": {...items["daggers"], "power": 10},
        //     },
        //     "defaultItems": {
        //         "0": {...items["basic-strike"], "power": 10},
        //         "1": {...items["basic-strike"], "power": 10},
        //         "2": {...items["basic-shield"], "power": 10},
        //         "3": {...items["basic-shield"], "power": 10},
        //         "4": {...items["basic-strike"], "power": 10},
        //         "5": {...items["basic-strike"], "power": 10},
        //     },
        // },
        // "kaz": {
        //     "key": "kaz",
        //     "jobKey": "ember/kaz",
        //     "isOverworldVisible": true,
        //     "isOverworldSelectable": false,
        //
        //     // "items": [
        //     //     {
        //     //         "name": "Spear",
        //     //         "element": "water",
        //     //         "attacktype": "steel",
        //     //         "attackrange": {
        //     //             "min": 1,
        //     //             "max": 1,
        //     //             "directions": [
        //     //                 {"x": -1, "y": 0},
        //     //                 {"x": +1, "y": 0},
        //     //                 {"x": 0, "y": -1},
        //     //                 {"x": 0, "y": +1},
        //     //
        //     //                 {"x": -1, "y": -1},
        //     //                 {"x": -1, "y": +1},
        //     //                 {"x": +1, "y": -1},
        //     //                 {"x": +1, "y": +1},
        //     //             ]
        //     //         },
        //     //         "power": 20,
        //     //         "skillKeys": ["attack"],
        //     //         "weaponImageKey": "ember-spear",
        //     //         // "weaponImage": require("@fae/source/assets/images/ember-tactics/sprites/weapons/wpn-memento-kazmace.png"),
        //     //     },
        //     // ],
        //
        //     "passives": [
        //         // ...
        //     ],
        //     "items": {
        //         "0": {...items["icicle-lance"], "power": 20},
        //         "1": {...items["icicle-lance"], "power": 10},
        //         "2": {...items["icicle-lance"], "power": 10},
        //         "3": {...items["flaming-crossbow"], "power": 10},
        //         "4": {...items["flaming-crossbow"], "power": 10},
        //         "5": {...items["flaming-crossbow"], "power": 20},
        //     },
        //     "defaultItems": {
        //         "0": {...items["basic-strike"], "power": 10},
        //         "1": {...items["basic-strike"], "power": 10},
        //         "2": {...items["basic-shield"], "power": 10},
        //         "3": {...items["basic-shield"], "power": 10},
        //         "4": {...items["basic-strike"], "power": 10},
        //         "5": {...items["basic-strike"], "power": 10},
        //     },
        // },
        // "crescent": {
        //     "key": "crescent",
        //     "jobKey": "ember/crescent",
        //     "isOverworldVisible": false,
        //
        //     // "items": [
        //     //     {
        //     //         "name": "Magic",
        //     //         "element": "water",
        //     //         "attacktype": "magic",
        //     //         "attackrange": 1,
        //     //         "power": 60,
        //     //         "skillKeys": ["attack"],
        //     //     },
        //     // ],
        //
        //     "passives": [
        //         // ...
        //     ],
        //     "items": {
        //         "0": {...items["icicle-lance"], "power": 20},
        //         "1": {...items["icicle-lance"], "power": 10},
        //         "2": {...items["icicle-lance"], "power": 10},
        //         "3": {...items["flaming-crossbow"], "power": 10},
        //         "4": {...items["flaming-crossbow"], "power": 10},
        //         "5": {...items["flaming-crossbow"], "power": 20},
        //     },
        //     "defaultItems": {
        //         "0": {...items["basic-strike"], "power": 10},
        //         "1": {...items["basic-strike"], "power": 10},
        //         "2": {...items["basic-shield"], "power": 10},
        //         "3": {...items["basic-shield"], "power": 10},
        //         "4": {...items["basic-strike"], "power": 10},
        //         "5": {...items["basic-strike"], "power": 10},
        //     },
        // },
    },
}
